<template>
  <div class="table-multi">
    <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-loading="isLoading"
        :header-cell-style="{background:'#f2f2f2'}"
        stripe
        style="border: 1px solid #ebeef5;"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          v-for="(tHead, thIndex) in tableHead"
          v-if="!tHead.operate"
          :key="'th-' + thIndex"
          :width="tHead.width"
          :prop="tHead.value"
          :label="tHead.label">
      </el-table-column>
      <el-table-column v-else
                       :width="tHead.width"
                       :label="tHead.label">
        <template slot-scope="scope">
          <button class="tb-btn" :class="'tb-btn-'+handler.type" v-for="(handler, index) in tableHandler"
                  :key="'handler'+ index"
                  @click="handleButton(handler.methods, scope.row)">{{handler.label}}</button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;padding-left: 14px;" v-if="tableData.length > 0">
      <el-checkbox v-model="checkAll" @change="toggleSelection()"></el-checkbox>
      <span class="wl-btn-del" @click="handleButton('delAll',SelectionData)">批量删除</span>
    </div>
    <pagenations
        :total="total"
        :size="size"
		v-if="total > 10"
        @pageHandler="pageOperate">
    </pagenations>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'
  export default {
    name: 'table-multi',
    props:{
      /**
       * 表单数据
       */
      tableData:{
        type: Array,
        required:true,
      },
      /**
       * 表头
       */
      tableHead:{
        type: Array,
        required: true,
      },
      /**
       * 表的操作
       */
      tableHandler: {
        type: Array,
        default: () => []
      },
      isLoading: {
        type: Boolean,
        default: () => false
      },
      total: {
        type: Number,
        default: () => 0
      },
      size:{
        type:Number,
        default:() => 10
      }
    },
    components:{
      pagenations
    },
    data() {
      return {
        checkAll:'',
        SelectionData:[]
      }
    },
    mounted() {

    },
    methods: {
      handleSelectionChange(val){
        if(val.length == this.tableData.length && val.length > 0){
          this.checkAll = true
        }else {
          this.checkAll = false
        }
        this.SelectionData = val
      },
      toggleSelection() {
        if (this.checkAll) {
          this.$refs.multipleTable.toggleAllSelection();
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleButton(methods, row){
        if(methods == "delMethods" || methods == "delAll"){
          if(this.SelectionData.length == 0 && methods == "delAll"){
            this.$message({
              message: '请选择要删除的数据',
              type: 'error'
            })
            return false
          }
          this.$confirm('正在进行删除操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.checkAll = false
            this.$emit("handleButton",{"methods":methods,"row":row})
          }).catch(() => {

          });
        }else {
          this.$emit("handleButton",{"methods":methods,"row":row})
        }
      },
      pageOperate(val){
        this.$emit("pageHandler",val)
      }
    }
  }
</script>

<style lang="scss">
.table-multi{
  width: 100%;
  .el-table{
    font-size: 12px;
    color: #666;
  }
  .tb-btn{
    background: none;
    border: 1px solid #999999;
    color: #666;
    border-radius: 2px;
    font-size: 12px;
    padding: 0;
	width: 65px;
	line-height: 20px;
    cursor: pointer;
    outline: none;
    &.tb-btn-edit,&.tb-btn-operate{
      border-color: #428efe;
      color: #428efe;
    }
    &.tb-btn-del{

    }
  }
  .tb-btn + .tb-btn{
    margin-left: 10px;
  }
  .wl-btn-del{
	margin-left: 15px;
  }
  .pageNations{
    text-align: right;
    padding-top: 22px;
  }
}
</style>
